module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921132649_T.5b71af1f.jpg";